import {
  InternalAccountNumber,
  money,
} from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const myAccountsQuery = gql`
  query MyAccounts {
    myAccounts {
      internal {
        ... on InternalSavingsAccount {
          ...InternalAccountNumber
          accountNumber
        }
        ... on InternalCheckingAccount {
          ...InternalAccountNumber
          accountNumber
          iconUrl
          availableBalance {
            ...money
          }
          institution {
            name
          }
        }
      }
    }
  }
  ${InternalAccountNumber}
  ${money}
`;
export default myAccountsQuery;
